export enum MatchArchiveFilterButtonLabels {
  ALL = 'All',
  INTERESTED = 'Interested',
  NO_THANKS = 'No thanks',
}

export enum MatchArchiveFilterTypes {
  ALL = 'all',
  INTERESTED = 'interested',
  NO_THANKS = 'no_thanks',
}

export enum DashboardViewStates {
  NOT_OPEN_TO_MATCHES = 'not-open-to-matches',
  LOADING = 'loading',
  NO_ARCHIVED_MATCHES = 'no-archived-matches',
  HAS_ARCHIVED_MATCHES = 'has-archived-matches',
}
